/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useRef as r}from"react";import{useWindowEvent as e}from"./use-window-event.js";var a,o=((a=o||{})[a.Forwards=0]="Forwards",a[a.Backwards=1]="Backwards",a);function t(){let a=r(0);return e("keydown",(r=>{"Tab"===r.key&&(a.current=r.shiftKey?1:0)}),!0),a}export{o as Direction,t as useTabDirection};
//# sourceMappingURL=use-tab-direction.js.map
